import Tooltip from '@components/shared/Tooltip'
import { Token } from 'config/tokens'
import { Dictionary } from 'lodash'
import { getColorGlow, getTokenColor } from 'rfx/lib/utils'

interface VaultAllocationBarsProps {
  allocations?: {
    address: string
    name: string
    subName: string
    allocationPercentage: string
  }[]
  tokens: Dictionary<Token>
}

const VaultAllocationBars = ({ allocations }: VaultAllocationBarsProps) => {
  return (
    <div className="flex w-full gap-1">
      {allocations?.map((allocation) => {
        return (
          <div
            className="relative h-2"
            style={{
              backgroundColor: getTokenColor(allocation?.name?.split('/')[0]),
              boxShadow: getColorGlow(
                getTokenColor(allocation?.name?.split('/')[0]),
              ),
              width: `${allocation?.allocationPercentage}%`,
            }}
          >
            <Tooltip
              className="h-full w-full"
              placement="bottom-start"
              content={
                <div className="flex flex-col gap-1">
                  <span>{allocation.name}</span>
                  <span>{allocation.allocationPercentage}%</span>
                </div>
              }
            >
              <div className="absolute left-0 top-0 h-full w-full" />
            </Tooltip>
          </div>
        )
      })}
    </div>
  )
}

export default VaultAllocationBars
